/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { OrderInvoiceViewModel } from "./OrderInvoiceViewModel";

export class GetOrderInvoiceViewModel {
    orderInvoiceViewModel: OrderInvoiceViewModel;
}
